import { useNavigate } from 'react-router-dom';
import NavBar from '@/components/landing/NavBar';
import HeroSection from '@/components/landing/HeroSection';
import {
  ProblemSection, WarningSignsSection, FrameworkSection, AudienceSection,
} from '@/components/landing/FeatureSections';
import PricingSection, { ReportPreviewSection } from '@/components/landing/PricingSection';
import {
  InsightToImprovementSection, AdvisorySection, WhyChooseSection,
} from '@/components/landing/JourneySections';
import ConsultationSection from '@/components/landing/ConsultationSection';
import { ContactSection, SiteFooter } from '@/components/landing/ContactFooter';

// Final landing page composition.
// Section order matches the published copy structure:
//   1. Hero
//   2. Why Automation and AI Projects Often Fail
//   3. Common Signs Your Workflow May Not Be Ready
//   4. What AWSAI Assesses
//   5. Who Should Use AWSAI
//   6. What You Receive (Free vs Professional)
//   7. Professional Report Preview
//   8. From Diagnostic Insight to Practical Improvement
//   9. Advisory and Transformation Support
//  10. Why Organisations Choose AWSAI
//  11. Discuss Your Results With an Advisor
//  12. Start With a Free AWSAI Assessment
//  13. Footer

const LandingPage = () => {
  const navigate = useNavigate();
  const goToAssessment = () => navigate('/assessment');
  const goToAdminLogin = () => navigate('/admin/login');

  return (
    <div className="min-h-screen bg-white">
      <NavBar onAdminLogin={goToAdminLogin} />
      <HeroSection onStart={goToAssessment} />
      <ProblemSection />
      <WarningSignsSection />
      <FrameworkSection />
      <AudienceSection />
      <PricingSection onStart={goToAssessment} />
      <ReportPreviewSection />
      <InsightToImprovementSection />
      <AdvisorySection />
      <WhyChooseSection />
      <ConsultationSection />
      <ContactSection onStart={goToAssessment} />
      <SiteFooter />
    </div>
  );
};

export default LandingPage;
